import _ from 'lodash';
import { FinancialPlanningSoftware } from '../../../logic/domains/epi.domain';

const DEPRECATED_OPTION = 'OTHER';

export const deprecatedPredicate = (o: FinancialPlanningSoftware) => {
	return o.value.toUpperCase() !== DEPRECATED_OPTION;
};

export const toFpsIdentifier = (option: FinancialPlanningSoftware): string => {
	return `${option.id.toString()}:${_.camelCase(option.value)}`;
};

export const toFpsId = (option: FinancialPlanningSoftware): string => {
	return option.id.toString();
};

export const toFPSMapper = (options: FinancialPlanningSoftware[]) => (
	identifier: string
): FinancialPlanningSoftware => {
	return options.find(
		o => toFpsIdentifier(o) == identifier
	) as FinancialPlanningSoftware;
};
